import React, { useRef, useState, useEffect } from 'react'
import html2canvas from 'html2canvas';
import { useReactToPrint } from 'react-to-print';
import "../styleCV/CV03.css"
import { Link } from 'react-router-dom';

const CV03 = () => {

    document.body.style.background = "white";

    const [Image, setImage] = useState()
    const [fname, setfname] = useState()
    const [lname, setlname] = useState()
    const [jobTitle, setjobTitle] = useState()
    const [phone, setphone] = useState()
    const [email, setemail] = useState()

    //address info
    const [street, setstreet] = useState()
    const [city, setcity] = useState()
    const [state, setstate] = useState()
    const [country, setcountry] = useState()
    const [postcode, setpostcode] = useState()

    //educational details 
    const [educationHTML, seteducationHTML] = useState()

    //summary
    const [CVDescription, setCVDescription] = useState()

    //skills 
    const [CVSkills, setCVSkills] = useState()

    //Experience
    const [experienceHTML, setexperienceHTML] = useState()

    //Project info
    // const [projectInfoHTML, setprojectInfoHTML] = useState()
    
    //achievements 
    const [CVAchievements, setCVAchievements] = useState()
    
    //languages
    const [langs, setLangs] = useState()

    useEffect(() => {
        //image photo 
        setImage(localStorage.getItem("profilePhoto"));

        //fetch objs from storage 
        const personalInfo = JSON.parse(localStorage.getItem("personalDetails"))
        //personal info
        if (personalInfo !== null) {
            setfname(personalInfo.firstname)
            setlname(personalInfo.lastname)
            setjobTitle(personalInfo.jobtitle)

            //contact info
            setphone(personalInfo.phone)
            setemail(personalInfo.email)

            //address info
            setstreet(personalInfo.address)
            setcity(personalInfo.city)
            setstate(personalInfo.state)
            setcountry(personalInfo.country)
            setpostcode(personalInfo.postcode)
        }

        //educational info
        const education = JSON.parse(localStorage.getItem("Education"));
        populateEducation(education)

        //summary
        setCVDescription(localStorage.getItem("CVDescription"));
        
        //languages
        setLangs(localStorage.getItem("cvlangs"));

        //Experience
        const experience = JSON.parse(localStorage.getItem("ProfessionalExperience"))
        populateExperience(experience);

        //skills
        const skills = JSON.parse(localStorage.getItem('skills'));
        populateSkills(skills)

        //achievements
        const achievements = JSON.parse(localStorage.getItem('achievements'));
        populateAchievements(achievements)
        
        //project Info
        // const projectInfo = JSON.parse(localStorage.getItem('projectInfo'));
        // populateProject(projectInfo);
    }, [])
    

    const populateAchievements = (achievements) => {
        if (achievements[0].achievements !== "") {
            setCVAchievements(
                <>
                    <div className="boxp03" id="Achievementsp03">
                        <h3 className="titlep03" id="Achievementstitlep03">Achievements</h3>
                        <ul className='achievementlistp03'>

                            {achievements.map((ach, index) => (

                                <li className="listitemp03">{ach.achievements}</li>

                            ))}
                        </ul>
                    </div>
                </>
            )
        }
    }

    const populateSkills = (skills) => {
        if (skills[0].skill !== "") {
            setCVSkills(
                <>
                    <div className="boxp03" id="Skillsp03">
                        <h3 className="titlep03" id="Skillstitlep03">Skills</h3>
                        <ul className='skilllistp03'>

                            {skills.map((sk, index) => (

                                <li className="listitemp03">{sk.skill}</li>

                            ))}
                        </ul>
                    </div>
                </>
            )
        }
    }

    const populateExperience = (experience) => {
        if (experience[0].WorkSummary !== "" || experience[0].StartDate !== "" || experience[0].PositionTitle !== "" || experience[0].EndDate !== "" || experience[0].ComponyName !== "") {
            setexperienceHTML(
                <>
                    <h3 className="titlep03" id="expertitlep03">Experience</h3>
                    {experience.map((exp, index) => (
                        <div key={index} className="experienceblock">
                            <div>
                                <div className="jobtitlep03">
                                    <label>{exp.PositionTitle}</label>
                                </div>
                                <div className='companynamep03'>
                                    <span>{exp.CompanyName}</span>
                                </div>
                                <div className="durationp03">
                                    <span className="startdatep03">{exp.StartDate}</span><span>-</span><span className="lastdatep03">{exp.EndDate}</span>
                                </div>
                                <div className="descriptionp03">{exp.WorkSummary}</div>
                            </div>
                        </div>
                    ))}
                </>
            )
        }
    }

    const populateEducation = (education) => {
        if (education[0].schname !== "" || education[0].schloc !== "" || education[0].field !== "" || education[0].edustrdate !== "" || education[0].eduendate !== "" || education[0].deg !== "") {
            seteducationHTML(
                <>
                    <h3 className="titlep03" id="educationtitlep03" >Education</h3>
                    <ul class="leftsidelist1p03">
                        {education.map((edu, index) => (
                            <li>
                                <div>
                                    <h4><span>{edu.deg}</span> in <span>{edu.field}</span></h4>
                                </div>
                                <div><span>{edu.edustrdate}</span> - <span>{edu.eduendate}</span></div>
                                <div>{edu.schname}</div>
                                <div>{edu.schloc}</div>
                            </li>

                        ))}
                    </ul>
                </>
            )
        }
    }

    // const populateProject = (projectInfo) => {
    //     if (projectInfo[0].projectTitle !== "" || projectInfo[0].projectDesc !== "") {
    //         setprojectInfoHTML(
    //             <>
    //                 <div className="boxp03" id="projectp03">
    //                     <h3 className="titlep03" id="protitp03" >Project</h3>
    //                     <div className="projectsListp03">
    //                         {projectInfo.map((prj, index) => (
    //                             <div className="Pro1p03">
    //                                 <div className="protitlep03">{prj.projectTitle}</div>
    //                                 <div className="prodescripp03">{prj.projectDesc}</div>
    //                             </div>
    //                         ))}
    //                     </div>
    //                 </div>
    //             </>
    //         )
    //     }
    // }

    const table = document.getElementById('CVp03');

    const componentRef = useRef();
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });



    const downloadImage = () => {
        html2canvas(table).then(function (canvas) {
            const link = document.createElement('a');
            link.download = 'business.png';
            link.href = canvas.toDataURL('image/png');
            link.click();
        });
    }


    return (<>
        <div className="containerp03">

            <div className="CVp03" ref={componentRef} id="CVp03">

                <div className='upperpartp03'>
                    {/* <div className='imgnameclass'> */}
                    <div className='imgcontainerp03'>
                        <img className='userPhotop03' src={Image} alt="" />
                    </div>

                    <div className='fullnameAndPostp03'>

                        <div className='namep03'>
                            <span className='fullNamep03'><span>{fname}</span>&nbsp;<span>{lname}</span></span>
                        </div>

                        <div className='positionp03'>
                            <span className='posp03'>{jobTitle}</span>
                        </div>
                    </div>

                    {/* </div> */}

                    <div className='boxp03' id="contactinfop03" >
                        <h3 className="titlep03" id='conttitle'>Contact</h3>
                         
                        <ul classname="leftsidelistp03">
                            <li>
                                <span className="iconp03" id="icon1p03"><i class="fa fa-phone" aria-hidden="true"></i></span>
                                <span className="text1p03">{phone}</span>
                            </li>
                            <li className='list2p03'>
                                <span className="iconp03" id="icon2p03"><i class="fa fa-envelope-o" aria-hidden="true"></i></span>
                                <span className="text2p03">{email}</span>
                            </li>
                            {/* <li className='list3itemp03'>
                <span className="iconp03" id="icon3p03"><i class="fa fa-linkedin-square" aria-hidden="true"></i></span>
                <span className="text3p03">www.linked.com </span>
              </li> */}
                            <li className='list4p03'>
                                <span className="iconp03" id="icon4p03"><i class="fa fa-map-marker" aria-hidden="true"></i></span>
                                <div className='addresp03'>
                                    <span className="text4p03" ><span>{street}</span>, <span>{city}</span><span>, </span><span>{state}</span>, <span>{country}</span>&nbsp;(<span>{postcode}</span>)</span>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="lowerpartp03">

                    <div className="leftsidep03">
                        <div className='boxp03' id="Educationp03">
                            {/* <h3 className="titlep03" id="educationtitlep03" >Education</h3> */}
                            {/* <ul class="leftsidelist1p03">
                                <li>
                                    <div>
                                        <h4>Masters degree in computer science</h4>
                                    </div>
                                    <div>2031-2033</div>
                                    <div>d.y.patil university</div>
                                    <div>123 Anywhere st, Any city</div>
                                </li>
                                 
                            </ul> */}
                    
                            {educationHTML}
            
                        </div>

                        {/* <div className="boxp03" id="Skillsp03">
                            <h3 className="titlep03" id="Skillstitlep03">Skills</h3>
                            <ul className='skilllistp03'>
                                <li className="listitemp03">problem solving</li>
                            </ul>
                        </div> */}
                        {CVSkills}
                        
                        {CVAchievements}
                        
                        <div className="boxp03" id="langboxp03" >
                            <h3 className="titlep03" id="langtitlep03">Languages</h3>
                            <div id="langp03" >{langs}</div>
                        </div>  


                    </div>

                    <div className="rightsidep03">
                        <div className="boxp03" id="summaryboxp03" >
                            <h3 className="titlep03" id="summarytitlep03">Summary</h3>
                            
                            <div id="summaryp03" >{CVDescription}</div>
                        
                        </div>

                        <div className="boxp03" id="experiencep03" >
                            
                            {/* <h3 className="titlep03" id="expertitlep03">Experience</h3> */}
                            {/* <div className="experienceblock">
                                <div className="jobtitlep03">
                                    <label>Full stack developer</label>
                                </div>
                                <div className='companynamep03'>
                                    <span>infosys | </span><span>123,pune shivaji road</span>
                                </div>
                                <div className="durationp03">
                                    <span className="startdatep03">2031</span><span>-</span><span className="lastdatep03">present</span>
                                </div>
                                <div className="descriptionp03">Lorem ipsum dolor sit amet consectetur adipisicing elit. Nihil cumque fugit praesentium quisquam neque adipisci quidem placeat similique molestias? Velit.</div>
                            </div> */}
                            {experienceHTML}
                        </div>

                        {/* project info */}
                        {/* {projectInfoHTML} */}

                        {/* <div className="boxp03" id="projectp03"> */}
                        {/* <h3 className="titlep03" id="protitp03" >Project</h3> */}
                        {/* <div className="projectsListp03">
                                <div className="Pro1p03">
                                    <div className="protitlep03">data structure library</div>
                                    <div className="prodescripp03">Lorem ipsum dolor sit amet consectetur adipisicing elit. Laborum, vero?</div>
                                </div>

                                <div className="pro2p03">
                                    <div className='protitlep03'>chatbot</div>
                                    <div className="prodescripp03">Lorem ipsum dolor sit amet consectetur adipisicing elit. Aspernatur repellendus incidunt fuga impedit veniam.</div>
                                </div>
                            </div> */}
                        {/* </div> */}
                    </div>
                </div>
            </div>
            {/* buttons to print the document */}
            <div className="container" style={{ "width": "100%", "display": "flex", "flexDirection": "row", "alignItems": "center", "justifyContent": "center", marginTop: "40px", "gap": "30px" }}>


                <Link to="/CVform1" k><button id='eidtForm' type="button" className="btn btn-success business03-btn">EDIT FORM</button></Link>
                <button id='mybtn' onClick={handlePrint} type="button" className="btn btn-success business03-btn">Download PDF</button>
                <button onClick={downloadImage} type="button" className="btn btn-success business03-btn">Download Image</button>

            </div>
            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    fontFamily: "kanit",
                    marginBottom: "20px",
                    marginTop: "30px"

                }}
            >
                <Link
                    to="/"
                    class="btn btn-outline-danger"
                    style={{ marginRight: "50px", width: "180px", fontSize: "18px" }}
                >
                    Back
                </Link>

                <Link to="/cv05"

                    class="btn btn-outline-success"
                    style={{ width: "180px", fontSize: "18px" }}
                >
                    Next
                </Link>

{/* <Link to="/" className="btn btn-outline-success"  >&nbsp;&nbsp;&nbsp;&nbsp;Edit form . .&nbsp;&nbsp;&nbsp;&nbsp;</Link>

<button id="mybtn" onClick={handlePrint} type="button" className="btn btn-outline-success mr-2">
  Download PDF
</button>
<button onClick={downloadImage} type="button" className="btn btn-outline-success" >
  Download Image
</button>

<Link to="/" className="btn btn-outline-success"  >&nbsp;&nbsp;&nbsp;&nbsp;Next&nbsp;&nbsp;&nbsp;&nbsp;</Link> */}

            </div>

        </div >

    </>
    )
}

export default CV03